import {Component, ElementRef, Inject, Injector, HostListener} from '@angular/core';
import {NgbActiveModal, NgbModalRef, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AppComponentBase} from '../../../../services/AppComponentBase';
import {showBuyingProcessModal} from '../../../appstore/appproduct-buypopup/appproduct-buypopup-modal';
import {AppstoreSuccessComponent} from '../../../appstore/appstore-success-notification/appstore-success-notification.component';
import {IAppStoreProduct} from '../../../appstore/interfaces/appstore-interfaces';
import {Utils} from '../../../../utils';




@Component({
    selector: "modal-ScannerTrialReminder",
    template: require('./ScannerTrialReminder.component.html'),
    styles: [require('./ScannerTrialReminder.component.css')]
})

export class ScannerTrialReminder extends AppComponentBase {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector);

        this.globaGridMode.appSuccessNotification.subscribe(l => {

            let product = this.workspace.producsList.filter(v => {
                return v.productId == l;
            })[0];

            if(this.workspace.lastPrId != l) {
                this.showSmallNotification(product.thumbnail);
                this.workspace.lastPrId = l;
            }

        });

    }

    // public lastId:string = ""

    private _dontShowAgain: boolean = false;
    public get dontShowAgain(): boolean {
        return this._dontShowAgain;
    }
    public set dontShowAgain(value: boolean) {
        this._dontShowAgain = value;

        if(value == true) {
            this.workspace.cookieService.setCookie("scannerInfoDontshow", "1", 10000);
        }
        else {
            this.workspace.cookieService.deleteCookie("scannerInfoDontshow");
        }

    }

    private _modalType: string = "afterTrial";
    public get modalType(): string {
        return this._modalType;
    }
    public set modalType(value: string) {
        this._modalType = value;
        if(value == "narrowScanner") {
            this.selectedSku = "scanner-level2";
        }
    }

    public get productPricing() {
        return this.workspace.producsList
    }

    public getProductState(sku: string) {
        return this.workspace.getProductActive(sku) && !this.workspace.getProductTrial(sku);
    }


    //public

    public openPopup(myURL:any, title:any, myWidth:any, myHeight:any) 
    {
        Utils.openPopup(myURL, title, myWidth, myHeight);
    }

    public openBuyingModal() {
        this.activeModal.close();
        showBuyingProcessModal(this.modalService, this.workspace.mobileMode).setProductToBuyInformation(this.selectedSku);
    }


    private _selectedSku: string = "";
    public get selectedSku(): string {
        return this._selectedSku;
    }
    public set selectedSku(value: string) {
        if(!this.getProductState(value))
            this._selectedSku = value;
    }

    public showSmallNotification(v: any) {
        let config = Object.assign(this.toastr.toastrConfig, {});
        config.timeOut = 6000;
        config.progressBar = true;
        config.closeButton = true;
        config.toastComponent = AppstoreSuccessComponent;

        let params: {} = {
            error: false,
            image: v
        };

        this.toastr.show(JSON.stringify(params), '', config);

    }

}


